<template>
  <footer>
    <div class="sponsors">
      <h3>{{ $t("footer.ourPartners") }}</h3>
      <div class="sponsors-list">
        <a v-for="sponsor in sponsors" :key="sponsor._id" :href="sponsor.Link">
          <img
            class="sponsor-image"
            :class="{ darken: sponsor.Darken }"
            :src="`${$bucketUrl}/images/sponsors/${sponsor._id}.png`"
            :alt="sponsor.Name ? sponsor.Name + ' - TKL sponsor' : 'TKL sponsor'"
            loading="lazy"
          />
        </a>
      </div>
    </div>
    <div class="info">
      <div class="footer-brand">
        <img class="info-logo" src="@/assets/TKL-white.png" alt="The Kings League logo" loading="lazy" />
        <p class="footer-desc">{{ $t("footer.description") }}</p>
      </div>
      <div class="site-map">
        <h3>{{ $t("footer.links") }}</h3>
        <ul>
          <li>
            <router-link to="/">{{ $t("pages.home") }}</router-link>
          </li>
          <li>
            <router-link to="/about-us">{{ $t("pages.aboutUs") }}</router-link>
          </li>
          <li>
            <router-link to="/contact-us">{{ $t("pages.contactUs") }}</router-link>
          </li>
          <li>
            <router-link to="/statistics">{{ $t("pages.statistics") }}</router-link>
          </li>
          <li>
            <router-link to="/register-team">{{ $t("registerTeam.registerCta") }}</router-link>
          </li>
          <li>
            <a :href="`${$bucketUrl}/rules.pdf`" download>{{
              $t("pages.rules")
            }}</a>
          </li>
          <router-link to="/privacy-policy">{{ $t("pages.privacy_policy") }}</router-link>
        </ul>
      </div>

      <div class="social">
        <h3>{{ $t("footer.followUs") }}</h3>
        <a href="https://www.facebook.com/TKLeague/" aria-label="Facebook">
          <img src="/facebook.png" alt="Facebook" loading="lazy" />
        </a>
        <a href="https://www.instagram.com/tkleague/" aria-label="Instagram">
          <img src="/instagram.png" alt="Instagram" loading="lazy" />
        </a>
        <a href="https://www.youtube.com/@TheKingsLeague" aria-label="YouTube">
          <img src="/youtube-logo.png" alt="YouTube" loading="lazy" />
        </a>
      </div>
    </div>
    <div class="copyright">
      <div>
        <p class="text-center">
          ©{{ new Date().getFullYear() }} The Kings League
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from "axios";
export default {
  name: "Footer",
  data() {
    return {
      sponsors: [],
    };
  },
  async created() {
    let res = await axios.get(this.$apiUrl + "/sponsors");
    this.sponsors = res.data;
  },
};
</script>
<style lang="scss" scoped>
@import "@/theme.scss";

footer {
  background: rgb(34, 34, 34);
  color: #999;
  box-shadow: 0 50vh 0 50vh rgb(34, 34, 34);
  padding: 5px;
}
h3 {
  @extend %font-bold;
  font-size: 18px;
  text-transform: uppercase;
  color: #fff;
  margin: 15px 0;
}

.sponsors {
  h3 {
    text-align: center;
    color: #999;
  }
}
.sponsors-list {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 15px 20px;
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 100px;
    margin: 10px;
  }
}
.sponsor-image {
  display: block;
  max-height: 90px;
  max-width: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  cursor: pointer;
  filter: grayscale(100%);
  &:hover {
    filter: grayscale(0%);
  }
  &.darken {
    filter: grayscale(100%) brightness(0.5);
    &:hover {
      filter: grayscale(0%) brightness(1);
    }
  }
}

.info {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: flex-start;
  padding: 0 7.5px;
  max-width: $max-width;
  margin: 15px auto 30px auto;
  font-size: 20px;
}
.footer-brand {
  max-width: 250px;
}
.info-logo {
  width: 200px;
}
.footer-desc {
  font-size: 13px;
  color: #777;
  line-height: 1.5;
  margin-top: 10px;
}
.site-map {
  width: 200px;
  font-size: 15px;
  text-align: center;
  ul {
    list-style-type: none;
  }
  li {
    margin: 2px 0;
  }
  a {
    color: #999;
    display: inline-block;
    padding: 1px 0;
    &:hover {
      color: white;
    }
  }
}
.social {
  width: 200px;
  text-align: center;
  a {
    padding: 8px;
    img {
      width: 32px;
      filter: brightness(0.5);
      &:hover {
        filter: brightness(1);
      }
    }
  }
}
.copyright {
  p {
    text-align: center;
    padding: 5px;
  }
}
@media only screen and (max-width: $mobile-breakpoint) {
  .info {
    flex-direction: column;
    align-items: center;
    & > * {
      margin: 10px 0;
    }
  }
  .social {
    width: 100%;
    text-align: center;
  }
}
</style>
